import { TextButton } from "@/design-system/TextButton/TextButton";
import {
  RangeFilterType,
  SelectorFilterType,
  UpdateFilterType,
} from "@/pages/Players/FiltersPanel/filterTypes";
import { countActivePlayerFilters } from "@/redux/squadBuilder/squadBuilderUtils";
import { useTranslation } from "@repo/shared/i18n";

import { useOutsideClick } from "../../../../../hooks/useOutsideClick";
import { PlayerFilters } from "../../../../organisms/Filters/PlayerFilters/PlayerFilters";
import { PanelContainer } from "../../components/PanelContainer/PanelContainer";
import { PanelHeader } from "../PanelHeader/PanelHeader";

type Props = {
  handleClickedClose: () => void;
  filters: (RangeFilterType | SelectorFilterType)[];
  handleUpdateFilter: (f: UpdateFilterType) => void;
  handleClearCustomFilter: (key: string) => void;
  handleClearPlayerFilters?: () => void;
};

export const PlayerFiltersMode = ({
  handleClickedClose,
  filters,
  handleUpdateFilter,
  handleClearCustomFilter,
  handleClearPlayerFilters,
}: Props) => {
  const { t } = useTranslation("squadBuilder");
  const activeFilterCount = countActivePlayerFilters(filters);
  const ref = useOutsideClick(() => {
    handleClickedClose();
  });
  return (
    <div ref={ref}>
      <PanelHeader
        title={t("panel.addPlayerFilters")}
        onClose={handleClickedClose}
      />
      <PanelContainer optionalPadding="sb-v2-lg:py-8 sb-v2-lg:px-4">
        {handleClearPlayerFilters && (
          // Inset to line up with the filter rows
          <div className="flex justify-end w-full px-2 mt-4">
            <TextButton
              onClick={handleClearPlayerFilters}
              disabled={activeFilterCount === 0}
            >
              {t("input.clearAllFilters", { amount: activeFilterCount })}
            </TextButton>
          </div>
        )}
        <div className="w-full mt-6">
          <PlayerFilters
            filters={filters}
            onChange={handleUpdateFilter}
            onClearFilter={handleClearCustomFilter}
            disabledFilters={[]}
            parentRoute="squad-builder"
            hiddenFilters={[
              "ownedOrEvolved",
              "country",
              "league",
              "club",
              "rarity",
              "position",
            ]}
          />
        </div>
      </PanelContainer>
    </div>
  );
};
